<div data-cy="project-new__page" mat-dialog-title>
  <h4 class="inline-block">{{ 'projects.new_project' | transloco }}</h4>
  <button data-cy="project-new__close-btn" type="button" class="close" (click)="close()">
    <span aria-hidden="true">
      <mat-icon class="d-text-middle">close</mat-icon>
    </span>
    <span class="sr-only">Close</span>
  </button>
</div>

<div *transloco="let t">
  <form data-cy="project-new__form-form" #form="ngForm" (submit)="submit()">
    <div mat-dialog-content class="enb-scroll pad-b">
      <div class="row">
          <div class="col-xs-12 col-md-4">
            <mat-form-field class="full-width">
                <mat-label>{{'projects.name_field' | transloco}}</mat-label>
                <input data-cy="project-new__name-input" matInput type="text" name="name" [(ngModel)]="project.name" (ngModelChange)="onNameChange($event)" required />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>{{'projects.code' | transloco}}</mat-label>
                <input data-cy="project-new__code-input" matInput type="text" name="code" [(ngModel)]="project.code" (ngModelChange)="onCodeChange()" required />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Project {{'reusable.project_setting.description' | transloco}}</mat-label>
                <textarea data-cy="project-new__description-input" matInput name="description" [(ngModel)]="project.description" required></textarea>
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>{{'projects.identifier' | transloco}}</mat-label>
                <input data-cy="project-new__identifier-input" matInput type="text" name="identification" [(ngModel)]="project.identifier" />
              </mat-form-field>
              <app-generic-multiselect-checkbox data-cy="project-new__generic-multiselect-checkbox" placeholder="Module(s)*" name="stakeholders" [(ngModel)]="project.modules" (ngModelChange)="onModuleChange($event)" [maxShownChips]="2">
                <app-generic-multiselect-checkbox-option *ngFor="let module of modules" [value]="module">
                  {{ 'reusable.project_setting.'+module.module_id | transloco | capitaliz }}
                </app-generic-multiselect-checkbox-option>
              </app-generic-multiselect-checkbox>
              <app-generic-multiselect-checkbox data-cy="project-new__generic-multiselect-checkbox-2" placeholder="Project type" name="project_type" [(ngModel)]="selectProjectType">
                <app-generic-multiselect-checkbox-option *ngFor="let type of projectTypes" [value]="type">
                  {{ 'project_type.project_type_'+type.id | transloco }}
                </app-generic-multiselect-checkbox-option>
              </app-generic-multiselect-checkbox>
              <app-generic-multiselect-checkbox data-cy="project-new__generic-multiselect-checkbox-3" [placeholder]="'Project ' + ('reusable.project_setting.phase' | transloco)" name="project_phase" [(ngModel)]="selectProjectPhase">
                <app-generic-multiselect-checkbox-option *ngFor="let phase of projectPhases" [value]="phase">
                  {{ 'project_phase.project_phase_'+phase.id | transloco }}
                </app-generic-multiselect-checkbox-option>
              </app-generic-multiselect-checkbox>
              <!-- later release -->
              <!-- <div>
                <app-generic-multiselect-checkbox [hideCancleIcon]="true" [multiple]="false" [placeholder]="t('settings.language')" name="multilingual"  [(ngModel)]="language" [required]="true">
                  <app-generic-multiselect-checkbox-option *ngFor="let lang of multilingual; trackBy: trackByFn" [value]="lang">
                      {{ lang.title | capitaliz }}
                  </app-generic-multiselect-checkbox-option>
                </app-generic-multiselect-checkbox>
              </div> -->
          </div>
          <div class="col-xs-12 col-md-8">
              <label class="material-style-label text-capitalize">
                  {{ t('projects.map_field') }}
                </label>
              <app-openlayers-map data-cy="project-new__openlayers-map" [(ngModel)]="project.polygons"
                                  name="polygons"
                                  [includeSidebar]="false"
                                  [defaultCoordinate]="globals.nederlandMap"
                                  [showMapReset]="true"
                                  [showPinTooltip]="false"
                                  [singleEntityType]="true"
                                  locatableType="projects"
                                  defaultDrawTool="area"
                                  clickStartDrawingMsg="Teken subprojectgebied"
                                  required
              >
              </app-openlayers-map>
          </div>
      </div>
    </div>
    
    <div mat-dialog-actions class="pull-right">
      <button data-cy="project-new__submit-btn" *ngIf="!processing" type="submit" mat-flat-button class="text-capitalize pull-right ml-10 mt-10" [disabled]="form.invalid">Toevoegen</button>
      <button data-cy="project-new__close-btn-2" *ngIf="!processing" mat-stroked-button class="text-capitalize pull-right mt-10" (click)="close()">{{ t('close') | capitaliz }}</button>
      <span *ngIf="processing" class="mt-10 pull-right loader-span">
        <img class="pull-left group_svg spinner" src="/assets/png/spinner.png" alt="decisions" />
        {{ 'projects.creating' | transloco }}
      </span>
    </div>
  </form>
</div>
